module.exports = __webpack_public_path__ + "static/overview03-e27b124aeef33ac05a0229612775a932.jpg";